import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Small delay so page loads first
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-2 sm:p-4 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-4xl mx-auto bg-slate-900 text-white rounded-xl sm:rounded-2xl shadow-2xl border border-slate-700 p-3 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <div className="flex items-start gap-2 sm:gap-3 flex-1">
          <Cookie className="w-5 h-5 sm:w-6 sm:h-6 text-amber-400 flex-shrink-0 mt-0.5" />
          <p className="text-xs sm:text-sm leading-relaxed">
            We use cookies to keep you logged in and improve your experience.{' '}
            <Link to="/policy/cookie-policy" className="text-emerald-400 hover:text-emerald-300 underline">
              Cookie Policy
            </Link>
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
          <Button onClick={decline} variant="ghost" size="sm" className="text-slate-300 hover:text-white hover:bg-slate-700 rounded-lg flex-1 sm:flex-none">
            Decline
          </Button>
          <Button onClick={accept} size="sm" className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg px-4 sm:px-6 flex-1 sm:flex-none" data-testid="accept-cookies-btn">
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
